import React from 'react';

export default ({ props, children }) => (
  <h6 className="mb-0 h6-text">{children}</h6>
);



// WEBPACK FOOTER //
// ./src/components/common/H6Text.js